<template>
  <div class="_make-article">
    
    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">การเพิ่มบอทเข้ากลุ่ม</h1>
    </header>
    <div class="MarkdownContent">
      <p class="preindent">เมื่อมีการเพิ่มบอทเข้ากลุ่ม ทาง One Chat จะส่งข้อมูลที่จำเป็นไปยัง webhook ที่ลงทะเบียนไว้ตามข้อมูลต่อไปนี้ </p>


    </div>


    <div class="MarkdownContent hidden-sm-and-down">
      <code class="codecolor" style="">
        <v-tooltip top >
<v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"event"</span> : <span class="colorvalue">"join"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ua521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"timestamp"</span> : <span class="colorvalue">"1462629479859"</span>,
    <span class="colorkey">"source"</span> : {
        <span class="colorkey">"type_source"</span> : <span class="colorvalue">"group"</span>,
        <span class="colorkey">"group_id"</span> : <span class="colorvalue">"GGb1fxxxxxx94fxxxxx594xxxxe7GGxxxx"</span>,
        <span class="colorkey">"group_name"</span> : <span class="colorvalue">"Group Name"</span>,
        <span class="colorkey">"sender"</span> : {
            <span class="colorkey">"user_id"</span> : <span class="colorvalue">"R5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
            <span class="colorkey">"email"</span> : <span class="colorvalue">"onechat@one.th"</span>,
            <span class="colorkey">"display_name"</span> : <span class="colorvalue">"One Chat"</span>
      }
    }
  }
      </code>

      <h3>รายละเอียดข้อมูลที่ได้รับ</h3>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>event</td>
          <td>String</td>
          <td>อีเว้นท์ของข้อมูลที่ได้รับ<br>
            <ul> <li>join เป็นอีเว้นท์เมื่อมีการชวนบอทเข้ากลุ่ม </li></ul></td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>timestamp</td>
          <td>Integer</td>
          <td>เวลาที่มีการชวนบอทเข้ากลุ่ม</td>
        </tr>
        <tr>
          <td>source</td>
          <td>Dictionary (json)</td>
          <td>รายละเอียดของบุคคลที่การชวนบอทเข้ากลุ่ม
            <ul><li>type_source คือประเภทของห้องแชท ซึ่งจะเป็น group</li>
            <li>group_id คือ รหัสเฉพาะของกลุ่ม</li>
            <li>group_name คือ ชื่อของกลุ่ม</li>
            <li>sender คือ ข้อมูล Dictionary (json) เกี่ยวกับบุุคคลที่ชวนบอทเข้ากลุ่ม</li>
            - user_id คือ รหัสเฉพาะของบุคคที่ชวนบอทเข้ากลุ่ม<br> 
            - email คือ อีเมล์ของบุคคลที่ชวนบอทเข้ากลุ่ม<br> 
            - display_name คือ ชื่อของบุคคลที่ชวนบอทเข้ากลุ่ม<br></ul>
          </td>
        </tr>
      </table>
    </div>

    <!-- mobile -->
    <div class="MarkdownContent hidden-md-and-up">
      <code class="codecolormo" style="">
        <v-tooltip top >
<v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"event"</span> : <span class="colorvalue">"join"</span>,
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ua521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"timestamp"</span> : <span class="colorvalue">"1462629479859"</span>,
    <span class="colorkey">"source"</span> : {
        <span class="colorkey">"type_source"</span> : <span class="colorvalue">"group"</span>,
        <span class="colorkey">"group_id"</span> : <span class="colorvalue">"GGb1fxxxxxx94fxxxxx594xxxxe7GGxxxx"</span>,
        <span class="colorkey">"group_name"</span> : <span class="colorvalue">"Group Name"</span>,
        <span class="colorkey">"sender"</span> : {
            <span class="colorkey">"user_id"</span> : <span class="colorvalue">"R5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
            <span class="colorkey">"email"</span> : <span class="colorvalue">"onechat@one.th"</span>,
            <span class="colorkey">"display_name"</span> : <span class="colorvalue">"One Chat"</span>
      }
    }
  }
      </code>

      <h3>รายละเอียดข้อมูลที่ได้รับ</h3>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>event</td>
          <td>String</td>
          <td>อีเว้นท์ของข้อมูลที่ได้รับ<br>
            <ul> <li>join เป็นอีเว้นท์เมื่อมีการชวนบอทเข้ากลุ่ม </li></ul></td>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>timestamp</td>
          <td>Integer</td>
          <td>เวลาที่มีการชวนบอทเข้ากลุ่ม</td>
        </tr>
        <tr>
          <td>source</td>
          <td>Dictionary (json)</td>
          <td>รายละเอียดของบุคคลที่การชวนบอทเข้ากลุ่ม
            <ul><li>type_source คือประเภทของห้องแชท ซึ่งจะเป็น group</li>
            <li>group_id คือ รหัสเฉพาะของกลุ่ม</li>
            <li>group_name คือ ชื่อของกลุ่ม</li>
            <li>sender คือ ข้อมูล Dictionary (json) เกี่ยวกับบุุคคลที่ชวนบอทเข้ากลุ่ม</li>
            - user_id คือ รหัสเฉพาะของบุคคที่ชวนบอทเข้ากลุ่ม<br> 
            - email คือ อีเมล์ของบุคคลที่ชวนบอทเข้ากลุ่ม<br> 
            - display_name คือ ชื่อของบุคคลที่ชวนบอทเข้ากลุ่ม<br></ul>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
    urleditmsgbot: '',
    message: '{\n\t"event" : "join",\n\t"bot_id" :"Ua521xx18350a5xxx2bxxxxx",\n\t"timestamp" : 1462629479859,\n\t"source" : {\n\t\t"type_source" : "group",\n\t\t"group_id" : "GGb1fxxxxxx94fxxxxx594xxxxe7GGxxxx",\n\t\t"group_name" : "Group Name",\n\t\t"sender" : {\n\t\t"user_id" : "R5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t\t"email" : "onechat@one.th", \n\t\t"display_name" : "One Chat"\n\t}\n\t}\n}'
  }),
  methods: {

  },
  created () {
    this.urleditmsgbot = process.env.APImanage + '/webhook/noti_addbot'
  }
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 90vw;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
    /*cursor: pointer;*/
}
#apifiletable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apifiletable td, #apifiletable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletable tr:nth-child(even){background-color: #f2f2f2;}

#apifiletable tr:hover {background-color: #ddd;}

#apifiletable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


#apifiletablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apifiletablemo td, #apifiletablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletablemo tr:nth-child(even){background-color: #f2f2f2;}

#apifiletablemo tr:hover {background-color: #ddd;}

#apifiletablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


/*.divbutton {
    height: 30px;
    background: #000;
}*/

.requestfile {
    display: none !important;
}

.codecolor:hover .requestfile {
    display: block !important;
}

.urlcopy {

    display: none !important;
}
.EndpointUrl:hover .urlcopy {
    display: inline !important;
}
.responsefile{
    display: none !important;
}

.codecolor:hover .responsefile {
    display: block !important;
}
#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/webhook/notiaddgroupwebhook.vue